<template>
  <div
    :class="{head: true, hasFixed: scrollOut}"
    :style="`background-color: ${backgroundColor};`"
  >
<!--    :style="`background-color: ${backgroundColor};`"-->
<!--    #cbb486-->
    <div>
      <a-menu v-model="current" mode="horizontal" style="text-align: left;">
        <a-menu-item
          v-for="item in headMenu"
          :key="item.key"
          @click="routeJumpe(item.key)"
        >
            {{item.name}}
        </a-menu-item>
      </a-menu>
      <div class="date">
        <img src="../../assets/images/icon_top_date.png"  class="date-img">
        {{ returnTime() }}
      </div>
    </div>
  </div>
</template>

<script>
import headMenu from './headMenu'
import moment from 'moment'
import { getPageTitle } from "@/api/moduleContent.js";
export default {
  name: 'head',
  data () {
    return {
      headMenu,
      current: ['home'],
      backgroundColor: '',
      scrollOut: false,
    }
  },
  methods: {
    getPageTitle(){
      getPageTitle().then(res=>{
        res.data.records && res.data.records.forEach(e => {
          if(e.resourceCode === "RESDE21F9ABC8451D0"){
            this.headMenu[0].name = e.resourceName
          }
          if(e.resourceCode === "RES4D60A3D3870DEA5"){
            this.headMenu[1].name = e.resourceName
          }
          if(e.resourceCode === "RESB640F0E2C6CDFA9"){
            this.headMenu[2].name = e.resourceName
          }
          if(e.resourceCode === "RES074C2AC49D371EC"){
            this.headMenu[3].name = e.resourceName
          }
          if(e.resourceCode === "RES957BA9CF725D908"){
            this.headMenu[4].name = e.resourceName
          }
          if(e.resourceCode === "RESC621EF2B6C36966"){
            this.headMenu[5].name = e.resourceName
          }
          if(e.resourceCode === "RESCFF81E7E2CD30B5"){
            this.headMenu[6].name = e.resourceName
          }
          if(e.resourceCode === "RES9B214B38CDA9E39"){
            this.headMenu[7].name = e.resourceName
          }
        });
      })
    },
    handleScroll() {
      let self = this
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 60) {
        self.scrollOut = true;
      } else {
        self.scrollOut = false;
      }
    },
    routeJumpe (key) {
      this.$router.push(key)
    },
    returnTime () {
      const o = {
        [1]: '一',
        [2]: '二',
        [3]: '三',
        [4]: '四',
        [5]: '五',
        [6]: '六',
        [7]: '日',
      }
      return moment().format('yyyy年MM月DD日 星期') + o[moment().format('E')]
    }
  },
  mounted() {
    this.getPageTitle()
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  watch: {
    $route: function (newval, oldVal) {
      if (newval) {
        this.current = [newval.path]
      }
      if (newval && newval.path && newval.path.indexOf('home') > -1) {
        this.backgroundColor = 'rgba(0,0,0, 0)'
      } else {
        this.backgroundColor = 'rgba(203, 180, 134, 1)'
      }
    }
  }
}

</script>

<style scoped lang='less'>
.head {
  position: relative;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  width: 100%;
  background: rgba(0, 0, 0, 0);
  > div {
    width: 1140px;
    position: relative;
    /*left: 50%;*/
    /*transform: translate(-50%);*/
    margin: auto;
  }
}
/deep/ .ant-menu-horizontal > .ant-menu-item:hover {
  color: white;
  border-bottom: 2px solid white;
}
/deep/ .ant-menu-horizontal > .ant-menu-item-selected {
  color: white;
  border-bottom: 2px solid white;
}
/deep/ .ant-menu-horizontal>.ant-menu-submenu-active {
  color: white;
  border-bottom: 2px solid white;
}
/deep/ .ant-menu {
  background: rgba(0, 0, 0, 0);
}
/deep/ .ant-menu-item {
  padding: 5px 0;
  margin: 0 22px;
  color: white;
}
/deep/ .ant-menu-horizontal {
  border-bottom: 0px;
}
.date {
  width: 240px;
  height: 15px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 18px;
  position: absolute;
  top: 20px;
  right: -14px;
  &-img {
    width: 24px;
    height: 24px;
    margin-top: -5px;
    vertical-align: middle;
  }
}
.hasFixed {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #cbb486!important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/head.vue